import "./src/css/style.css";
import { renderJobPosting } from "./src/components/Jobs/consoleJobPosting";
//require("prismjs/themes/prism-coy.css");
require("./src/css/prism-theme.css");

renderJobPosting();
